<template>
	<div id="Mcontent">
		<div class="amap-page-container">
	      <el-amap vid="amap" :zoom="zoom" :center="center" class="amap-demo">
	        <el-amap-info-window
	          :position="currentWindow.position"
	          :content="currentWindow.content"
	          :visible="currentWindow.visible"
	          :events="currentWindow.events">
	        </el-amap-info-window>
	      </el-amap>
	    </div>
	    <div>
	    	<div>交通指南</div>
	    	<div>青海省博物馆位于西宁市城西区西关大街58号，新宁广场东侧</div>
	    	<div>乘车路线：</div>
	    	<div>乘2路于虎台下车</div>
	    	<div>乘12路、18路、22路于新宁广场南下车</div>
	    	<div>乘9路、13路、25路、31路、85路、108路于新宁广场北下车。</div>
	    	<div>西宁火车站出发路线：</div>
	    	<div>22路：青藏铁路公司——新宁广场南</div>
	    	<div>35路：火车站广场西——新宁广场南</div>
	    	<div>40路：青藏铁路公司——新宁广场西</div>
	    	<div>西宁曹家堡机场出发路线：</div>
	    	<div>乘机场巴士至中心广场站，转乘24路、85路于新宁广场西站下车</div>
	    </div>
	</div>
</template>

  

<script>
    module.exports = {
      data () {
        return {
          zoom: 14,
          center: [101.755855,36.630000],
          windows: [
            {
              position: [101.755855,36.630000],
              content: '青海省博物馆',
              visible: true,
              events: {
                close() {
                  console.log('close infowindow1');
                }
              }
            }
          ],
          slotWindow: {
            position:[101.755855,36.630000]
          },
          currentWindow: {
            position: [101.755855,36.630000],
            content: '',
            events: {},
            visible: false
          }
        }
      },

      mounted() {
        this.currentWindow = this.windows[0];
      }
    };
</script>
<style scoped>
#Mcontent{
    height: 70%;
    width: 94%;
    margin-left: 3%;
    margin-right: 3%;
    margin-top: 3%;
}
.amap-demo {
	height: 300px;
}
#Mcontent>div:nth-child(2){
    width: 60%;
    margin-left: 20%;
    margin-right: 20%;
    margin-top: 1em;
}
#Mcontent>div:nth-child(2)>div:nth-child(1){
    font-size: 1.8em;
    line-height: 3em;
    font-weight: 700;
}
#Mcontent>div:nth-child(2)>div:nth-child(n+1){
	line-height: 2em;
}   
#Mcontent>div:nth-child(2)>div:nth-child(2){
	font-size: 1em;
}
#Mcontent>div:nth-child(2)>div:nth-child(3),
#Mcontent>div:nth-child(2)>div:nth-child(7),
#Mcontent>div:nth-child(2)>div:nth-child(11){
	font-size: 1.2em;
	font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/pages/about/contact.vue